import { Account } from '@/domain/usecases'
import { ContentCompletion } from '@/domain/usecases/content/content-completion'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs } from 'react-router-dom'
import FeatureFlagLoader from '../feature-flag-loader'

export default class ContentCompletionLoader extends FeatureFlagLoader {
  private static readonly ENROLLMENT_ID_PARAM = 'id'

  constructor(
    readonly account: Account.Model,
    redirectUrl: string,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient
  ) {
    super(account, redirectUrl, FeatureFlag.Key.NEW_ENROLLMENT_COMPLETION, ldClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    const id = params[ContentCompletionLoader.ENROLLMENT_ID_PARAM]
    if (id === undefined) return null

    return super.defer({
      data: super.importRemoteModule('makeRemoteContentCompletion').then(async makeRemote => {
        const remote = makeRemote(this.queryClient) as ContentCompletion
        return remote.get(id)
      })
    })
  }
}
